import { render, staticRenderFns } from "./CfopForm.vue?vue&type=template&id=5f4916f7"
import script from "./CfopForm.vue?vue&type=script&lang=js"
export * from "./CfopForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports